<template>
  <v-dialog v-model="dialogCreateShow" max-width="700px">
    <v-card class="pa-8 pa-sm-16">
      <v-btn class="button-close ma-4" icon @click="dialogCreateShow = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Шаг после создания -->
      <template v-if="createdClientId">
        <h2 class="text-center">Добавить менеджера?</h2>
        <p class="text-center mt-4 mb-0">
          Менеджеры нужны, если тесты распределяются по городам, филиалам или сотрудникам. Можно сделать позже.
        </p>
        <div class="row mt-6">
          <div class="col-md-6">
            <v-btn class="w-100" color="primary" outlined @click="openCreatedClient(false)">Не сейчас</v-btn>
          </div>
          <div class="col-md-6">
            <v-btn class="w-100" color="primary" @click="openCreatedClient(true)">Добавить менеджера</v-btn>
          </div>
        </div>
      </template>

      <template v-else>
      <h2 class="text-center">Данные корпоративного клиента</h2>
      <form @submit.prevent="createClientConfirm" class="mt-6">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <v-text-field label="Компания *" v-model="editedItem.company"
                @input="onInput('company')" @blur="$v.editedItem.company.$touch()"
                :error-messages="companyErrors" outlined dense />
            </div>
            <div class="col-md-6">
              <v-text-field label="Адрес эл. почты *" v-model.trim="editedItem.email"
                @input="clearError" @blur="$v.editedItem.email.$touch()"
                :error-messages="emailErrors" outlined dense />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <v-text-field label="ИНН" v-model.trim="editedItem.taxpayer_id_number"
                @input="onInput('taxpayer_id_number')" @blur="$v.editedItem.taxpayer_id_number.$touch()"
                :error-messages="innErrors" outlined dense />
            </div>
            <div class="col-md-6">
              <CorpPartnerSelect v-model="editedItem.supervisorId" :partners="partners" :type="PARTNER_TYPES.SUPERVISOR" @input="onInput"
                label="Супервизор" :loading="loadingPartners.load" :disabled="!canChangePartners"
                :error-messages="partnerError" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <CorpPartnerSelect v-model="editedItem.referrerId" :partners="partners" :type="PARTNER_TYPES.REFERRER" @input="onInput"
                label="Реферал" :loading="loadingPartners.load" :disabled="!canChangePartners"
                :error-messages="referrerError" />
            </div>
          </div>
          <div v-if="tagsAvailable" class="row">
            <div class="col-12">
              <CorpTagsSelect :value="tagIds" :error-messages="tagErrors" @input="onTagsChange" />
            </div>
          </div>
          <div class="text-subtitle-2 grey--text text--darken-1 mb-2">Менеджер</div>
          <div class="row">
            <div class="col-md-6">
              <v-text-field label="Фамилия *" :value="editedItem.last_name"
                @input="($v.editedItem.last_name.$model = upperFirst($event)), onInput('last_name')"
                :error-messages="lastnameErrors" outlined dense
              />
            </div>
            <div class="col-md-6">
              <v-text-field label="Имя *" :value="editedItem.first_name"
                @input="($v.editedItem.first_name.$model = upperFirst($event)), onInput('first_name')"
                :error-messages="firstnameErrors" outlined dense
              />
            </div>
          </div>
          <div v-if="PARTNER_FEATURES" class="row">
            <div class="col-md-6">
              <v-select v-model="editedItem.promocode"
                :items="codes" label="Промокод"
                item-text="title" item-value="id" outlined dense
              />
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6 mx-auto">
            <v-btn type="submit" class="w-100" color="primary" :loading="loading.create" :disabled="loading.create"> Создать </v-btn>
          </div>
        </div>
      </form>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint-disable*/
import api from '@/common/api';
import { mapActions, mapGetters } from 'vuex';
import { email, maxLength, required } from 'vuelidate/lib/validators';
import { cloneDeep, upperFirst } from 'lodash';
import { firstnameValidation, lastnameValidation, innValidation } from '@/common/validationHelpers';
import {
  CORP_COMPANY, EMAIL, FIRST_NAME, LAST_NAME,
} from '@/common/constants/validations';
import { MESSAGES } from '@/common/constants/errorMessages';
import { PARTNER_FEATURES } from '@/common/constants/features';
import CorpTagsSelect from '@/components/clients/tags/CorpTagsSelect.vue';
import CorpPartnerSelect from '@/components/clients/CorpPartnerSelect.vue';
import { PARTNER_TYPES, isPartnerOfType } from '@/common/models/partnerTypes';

export default {
  name: 'ClientCreateModal2',
  components: { CorpTagsSelect, CorpPartnerSelect },
  validations: {
    editedItem: {
      last_name: { required, lastnameValidation, maxLength: maxLength(LAST_NAME.MAX_LENGTH) },
      first_name: { required, firstnameValidation, maxLength: maxLength(FIRST_NAME.MAX_LENGTH) },
      email: { required, email, maxLength: maxLength(EMAIL.MAX_LENGTH) },
      company: { required, maxLength: maxLength(CORP_COMPANY.MAX_LENGTH) },
      taxpayer_id_number: { innValidation },
    }
  },
  data: () => ({
    editedItem: {
      last_name: '',
      first_name: '',
      supervisorId: null,
      referrerId: null,
      company: '',
      email: '',
      taxpayer_id_number: '',
      promocode: ''
    },
    defaultItem: {
      last_name: '',
      first_name: '',
      supervisorId: null,
      referrerId: null,
      email: '',
      company: '',
      taxpayer_id_number: '',
      promocode: ''
    },
    tagIds: [],
    createdClientId: null,
    codes: [],
    PARTNER_FEATURES,
    PARTNER_TYPES,
  }),
  watch: {
    async dialogCreateShow(val) {
      if (val) {
        this.tagIds = [];
        if (this.user && this.user.user_type === 'Admin') this.ensureTags();
        if (!this.partners?.length && !this.loadingPartners.load) {
          await this.loadPartners();
        }
        // Партнёр, создающий корпа, закрепляется за ним по своему типу
        if (this.user.user_type === 'Partner') {
          if (this.user.partner_type === PARTNER_TYPES.REFERRER) this.editedItem.referrerId = this.user.id;
          else this.editedItem.supervisorId = this.user.id;
        } else if (!this.canChangePartners && this.partners.length) {
          // Без права менять партнёров корп закрепляется за доступным партнёром, как и раньше
          const supervisor = this.partners.find((p) => isPartnerOfType(p, PARTNER_TYPES.SUPERVISOR));
          if (supervisor) this.editedItem.supervisorId = supervisor.id;
        }

        // if (!this.codes?.length) {
        //   await this.loadCodes({ user_type: this.user.user_type, id: this.user.id });
        // }
        // console.log('this.defaultRef', this.defaultRef);
      }
    },
    'editedItem.supervisorId': function () {
      if (PARTNER_FEATURES) this.loadCodes(this.editedItem.supervisorId);
    }
  },
  computed: {
    ...mapGetters({
      loading: 'users/clients/loading',
      errors: 'users/clients/errors',
      editedClient: 'users/clients/editedClient',
      partners: 'users/partners/partners',
      loadingPartners: 'users/partners/loading',
      defaultRef: 'profile/refs/defaultRef',
      user: 'auth/user',
      tagsAvailable: 'users/corpClientTags/available',
      allTags: 'users/corpClientTags/tags',
    }),
    // Ошибки по тегам: сервер называет поле tag_ids или tags
    tagErrors() {
      const found = this.errors.create.find((err) => err[0] === 'tag_ids' || err[0] === 'tags');
      return found ? [].concat(found[1]) : [];
    },
    dialogCreateShow: {
      get() {
        return this.$store.getters['users/clients/dialogCreateShow'];
      },
      set(val) {
        if (!val) {
          this.editedItem = cloneDeep(this.defaultItem);
          this.createdClientId = null;
          this.$v.$reset();
        }
        this.setDialogCreateShow(val);
      }
    },
    dialogDeleteShow: {
      get() {
        return this.$store.getters['users/clients/dialogDeleteShow'];
      },
      set(val) {
        this.setDialogDeleteShow(val);
      }
    },
    lastnameErrors() {
      const errors = [];
      if (!this.$v.editedItem.last_name.$dirty) return errors;
      if (!this.$v.editedItem.last_name.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.editedItem.last_name.lastnameValidation) errors.push(MESSAGES.INCORRECT_LASTNAME);
      if (!this.$v.editedItem.last_name.maxLength) errors.push(MESSAGES.MAX_LENGTH(LAST_NAME.MAX_LENGTH));

      return this.errors.create.find(err => err[0] === 'last_name')?.[1] ?? errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      if (!this.$v.editedItem.email.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.editedItem.email.email) errors.push(MESSAGES.INCORRECT_EMAIL);
      if (!this.$v.editedItem.email.maxLength) errors.push(MESSAGES.MAX_LENGTH(EMAIL.MAX_LENGTH));

      return this.errors.create.find((err) => err[0] === 'email')?.[1] ?? errors;
    },
    firstnameErrors() {
      const errors = [];
      if (!this.$v.editedItem.first_name.$dirty) return errors;
      if (!this.$v.editedItem.first_name.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.editedItem.first_name.firstnameValidation) errors.push(MESSAGES.INCORRECT_FIRSTNAME);
      if (!this.$v.editedItem.first_name.maxLength) errors.push(MESSAGES.MAX_LENGTH(FIRST_NAME.MAX_LENGTH));

      return this.errors.create.find(err => err[0] === 'first_name')?.[1] ?? errors;
    },
    companyErrors() {
      const errors = [];
      if (!this.$v.editedItem.company.$dirty) return errors;
      if (!this.$v.editedItem.company.required) errors.push(MESSAGES.REQUIRED);
      if (!this.$v.editedItem.company.maxLength) errors.push(MESSAGES.MAX_LENGTH(CORP_COMPANY.MAX_LENGTH));

      return this.errors.create.find(err => err[0] === 'company')?.[1] ?? errors;
    },
    innErrors() {
      const errors = [];
      if (!this.$v.editedItem.taxpayer_id_number.$dirty) return errors;
      if (!this.$v.editedItem.taxpayer_id_number.innValidation) errors.push(MESSAGES.INCORRECT_INN);

      return this.errors.create.find(err => err[0] === 'taxpayer_id_number')?.[1] ?? errors;
    },
    canChangePartners() {
      return this.$store.getters['auth/isAllowed']('change_partner_of_corpclient');
    },
    partnerError() {
      return this.errors.create.find(err => err[0] === 'supervisor')?.[1] ?? [];
    },
    referrerError() {
      return this.errors.create.find(err => err[0] === 'referrer')?.[1] ?? [];
    },
  },
  methods: {
    ...mapActions({
      clearError: 'users/clients/clearError',
      ensureTags: 'users/corpClientTags/ensureLoaded',
      reloadTags: 'users/corpClientTags/load',
      setDialogCreateShow: 'users/clients/setDialogCreateShow',
      setDialogDeleteShow: 'users/clients/setDialogDeleteShow',
      createClient: 'users/clients/createClient',
      loadPartners: 'users/partners/loadPartners',
    }),
    onInput() {
      if (this.errors.create.length) this.clearError();
    },
    async loadCodes() {
      try {
        this.editedItem.promocode = 0;
        if (!this.editedItem.supervisorId) {
          this.codes = [];
          return;
        }
        this.codes = await api.post(`/users/partners/${this.editedItem.supervisorId}/get-promocodes/`);
        this.codes = this.codes.filter(el => el.status !== 'expired')
        this.codes.push({ title: "-", id: 0 });

        this.editedItem.promocode = this.codes.find(el => el.is_default)
        if (!this.editedItem.promocode && this.codes.length)
          this.editedItem.promocode = this.codes[0];
        if (this.editedItem.promocode)
          this.editedItem.promocode = this.editedItem.promocode.id
        // this.editedItem.promocode = this.user.user_type === 'Partner' && this.defaultRef ? this.defaultRef.id : 0;
      } catch (err) {
        this.$toast.error("Ошибка при загрузке промокодов", '', { position: 'topRight' });
      }
    },

    onTagsChange(ids) {
      this.tagIds = ids;
      if (this.errors.create.length) this.clearError();
    },
    createClientConfirm() {
      if (this.loading.create) return;
      this.$v.$touch();
      if (this.editedItem && !this.$v.$invalid) {
        const { supervisorId, referrerId, ...rest } = this.editedItem;
        const form = { ...rest };
        // Привязки необязательны: пустые не отправляем
        if (supervisorId) form.supervisor = supervisorId;
        if (referrerId) form.referrer = referrerId;
        if (!form.taxpayer_id_number) delete form.taxpayer_id_number;
        if (this.tagsAvailable && this.tagIds.length) form.tag_ids = this.tagIds;
        if (PARTNER_FEATURES) {
          // Промокод выбирают в форме (в том числе «-») — промокод по умолчанию не применяем.
          form.use_default_promocode = false;
        } else {
          // Без партнёрки промокод не выбираем и не отправляем: какой применить, решает бэк (use_default_promocode по умолчанию true).
          delete form.promocode;
        }
        this.createClient(form).then((created) => {
          this.$toast.success('Корп. клиент создан', '', { position: 'topRight' });
          if (created && created.id && this.$store.getters['auth/isAllowed']('view_corpclient')) {
            this.createdClientId = created.id;
          } else {
            this.dialogCreateShow = false;
          }
        }).catch(async (err) => {
          console.log(err);
          this.$toast.error("Ошибка при создании корпоративного клиента", '', { position: 'topRight' });
          // Тег могли удалить параллельно: обновляем справочник и убираем из выбора то, чего уже нет
          if (form.tag_ids && this.tagErrors.length) {
            await this.reloadTags();
            const known = this.allTags.map((tag) => tag.id);
            this.tagIds = this.tagIds.filter((id) => known.includes(id));
          }

        });
      }
    },
    // Оба ответа ведут в карточку нового корпа; добавление менеджера из карточки — задача «Карточка компании».
    openCreatedClient(addManager) {
      const id = this.createdClientId;
      this.dialogCreateShow = false;
      this.$router.push({ name: 'clients-id', params: { id }, query: addManager ? { addManager: 1 } : {} });
    },
    upperFirst
  }
};
</script>
